import React from 'react';
import { useLanguage } from '../LanguageContext';
import { useScrollReveal } from '../hooks/useScrollReveal';

const BusinessTravel = () => {
  const { t } = useLanguage();
  const ref = useScrollReveal(['h2', 'p', '.business-card'], { stagger: 0.08 });

  return (
    <section className="business-section" id="business" ref={ref}>
      <span id="services" className="section-anchor" />
      <div className="business-content">
        <h2>{t.business.title}</h2>
        {t.business.paragraphs.map((p, i) => <p key={i}>{p}</p>)}
        <div className="business-grid">
          <div className="business-card">
            <h3>{t.business.card1.title}</h3>
            <ul>{t.business.card1.items.map((item, i) => <li key={i}>{item}</li>)}</ul>
          </div>
          <div className="business-card">
            <h3>{t.business.card2.title}</h3>
            <ul>{t.business.card2.items.map((item, i) => <li key={i}>{item}</li>)}</ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BusinessTravel;
